
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPaletteDimming as ObiPaletteDimmingElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-palette-dimming.js';
 
 
 

 
 export const ObiPaletteDimming = createComponent({
   react: React,
   tagName: 'obi-palette-dimming',
   elementClass: ObiPaletteDimmingElement,
   events: {
     
   }
  });
 
 